
  import {Component, Vue} from "vue-property-decorator";
  import AppPageHeader from "@/components/AppPageHeader.vue";
  import ScreenPayIntro from "@/modules/ScreenPay/components/ScreenPayIntro.vue";
  import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
  import ClaimsPopup from "@/modules/barriers/components/ClaimsPopup.vue";
  import CantExitPopup from "@/modules/Payment/components/CantExitPopup.vue";

  @Component({
    components: {
      CantExitPopup,
      AppPageHeader,
      ScreenPayIntro,
      ClaimsPopup,
    },
  })
  export default class PageScreenPay extends Vue {
    isLoading: boolean = true;

    get dialogs(): IDialogStoreState { return this.$store.state.dialog; }

    async created() {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('initialized');
      this.isLoading = false;
    }

  }
